import type { GroupedNodes, NodeStruct } from '@/types/node-types';

/**
 * Identity key for matching an imported node's struct to a catalog row.
 * Prefers `node_id` (snake_case node name) and falls back to
 * node_type:node_sub_type when node_id is missing.
 */
export function getCatalogNodeIdentityKey(
  struct: Pick<NodeStruct, 'node_id' | 'node_type' | 'node_sub_type'>,
): string {
  const id = struct.node_id?.trim();
  if (id) return id;
  return `${struct.node_type ?? ''}:${struct.node_sub_type ?? ''}`;
}

/** All catalog identity keys for membership checks (unsupported / disabled nodes). */
export function buildCatalogIdentitySet(
  groupedNodes: GroupedNodes,
): Set<string> {
  return new Set(
    Object.values(groupedNodes).flatMap((categoryNodes) =>
      categoryNodes.map((n) => getCatalogNodeIdentityKey(n)),
    ),
  );
}
